module.exports = __webpack_public_path__ + "img/good-job-emoji.2da66315.jpg";